import React from 'react';
// import Numeral from 'numeral'; // TODO: package not available
// import Request from 'superagent'; // TODO: package not available - HTTP requests disabled
import Moment from 'moment';

import Const from 'fw_const';
// -------------------------------------------------------

let fixedContentsY = 0;

/*
 * モーダル固定用
 */
function actionLoadingFlg(flg){
  let element = document.getElementById('api-loading');
  if (!element) return; // 要素がない場合の安全対策
  
  if( flg ){
    element.className = 'sub-loading on';
  } else {
    element.className = 'sub-loading off';
  }
};

export default {
  /*
   * 通信処理(共通)
   */
  request(url, data, success, error, loading_anm, finish_loading_anm){
    
    // エラー処理
    if( error == undefined || error == null ){
      error = (res) => { // アロー関数にして bind(this) を不要に
        if( res && res.body && res.body.msg != undefined ){
          alert(res.body.msg);
        } else if( res && res.body && res.body.message){
          alert(res.body.message);
        } else {
          alert('エラーが発生しました');
        }
      };
    }
    
    // TODO: superagent (Request) is not available. Replace with fetch or another HTTP client.
    // Request.post(url)
    //   .send(data)
    //   .timeout(Const.value.request_timeout)
    //   .end((err, res) => { ... });
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(r => r.json().then(body => ({ ok: r.ok, body })))
      .then(({ ok, body }) => {
        try {
          if( body && body.result == 'LOGOUT' ){
            location.href = '/logout';
            return;
          }
          if( ok && body && body.result == 'OK' ){
            if( finish_loading_anm !== false ) actionLoadingFlg(false);
            success({ body });
          } else {
            actionLoadingFlg(false);
            error({ body });
          }
        } catch(e) {
          console.log(e);
          actionLoadingFlg(false);
          error({ body: null });
        }
      })
      .catch(e => {
        console.log(e);
        actionLoadingFlg(false);
        error(null);
      });
    
    if( loading_anm !== false ) actionLoadingFlg(true);
  },
  // -------------------------------------------------------
  
  /*
   * モーダル固定用
   */
  handleTouchMove(event){
    event.preventDefault();
  },
  // -------------------------------------------------------
  
  /*
   * モーダル時に Body を固定する
   */
  fixedContents(){
    let element = document.getElementById('base-html');
    if( element && element.className.indexOf('fixed') === -1 ) {
      element.className = element.className +' fixed';
    }
  },
  // -------------------------------------------------------
  
  /*
   * モーダル時の Body 固定を解除する
   */
  unlockFixedContents(){
    let element = document.getElementById('base-html');
    if (element) {
      element.className = element.className.replace(/ fixed/ig, '');
    }
  },
  // -------------------------------------------------------
  
  /*
   * 操作端末を取得
   */
  getTerminal(){
    if ( window.innerWidth >  Const.value.device.tablet )     return 'pc';
    if ( window.innerWidth >  Const.value.device.smartphone ) return 'tablet';
    if ( window.innerWidth <= Const.value.device.smartphone ) return 'mobile';
    
    return 'pc';
  },
  // -------------------------------------------------------
  
  /*
   * 親のクラスを取得
   */
  getParentClass(ev, search){
    let max = 10;
    let result = null;
    let last_id = null;
    
    try {
      for( let i = 0; i <= max; i++ ){
        ev = ev.parentNode;
        if (!ev) break;
        
        result = ev.getAttribute('class');
        try { result = result.replace(' ',''); } catch(e) {}
        
        if( result != null ){
          if( result == search || ev.parentNode == document.body || result.indexOf(search) !== -1 ){
            i = max;
          }
        }
        
        last_id = ev.getAttribute('id');
      }
    } catch(e) {};
    
    if( last_id == 'base-html' ) result = null;
    
    return result;
  },
  // -------------------------------------------------------
  
  /*
   * テキストにタグを設定
   */
  tagReplace(text, exp, st, ed) {
    try {
      let m = text.match(exp);
      if (!m) return text;
      m.map((key) => {
        key = key.replace(/ /, '');
        if( key.length > 1 ) text = text.replace(new RegExp(key, 'g'), (st+ key +ed));
      });
      
      return text;
    } catch(e){
      return text;
    }
  },
  // -------------------------------------------------------
  
  /*
   * テキストにリンクタグを設定
   */
  linkReplace(text, link_hide=false) {
    try {
      var regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
      var regexp_makeLink = function(all, url, h, href) {
        url = url.replace('http://', '');
        url = url.replace('https://', '');
        
        return '<a href="h' + href + '" target="_blank">' + url + '</a>';
      }
      if( link_hide ) regexp_makeLink = '';
      
      return text.replace(regexp_url, regexp_makeLink);
    } catch(e){
      return text;
    }
  },
  // -------------------------------------------------------
  
  /*
   * リンクのアドレスを特定する
   */
  getLinkAddress(text) {
    try {
      let exp = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
      let m = text.match(exp);
      return m ? m[0] : undefined;
    } catch(e){
      return;
    }
  },
  // -------------------------------------------------------
  
  /*
   * カレンダー用の日付フォーマットに変更
   */
  pickerFormat(date){
    return Moment(date,'YYYY/MM/DD').format('DD/MM/YYYY');
  },
  // -------------------------------------------------------
  
  /*
   * 画面表示用のフォーマットに変更
   */
  dateFormat(date){
    return Moment(date,'DD/MM/YYYY').format('YYYY/MM/DD');
  },
  // -------------------------------------------------------
  
  getCondValue(data) {
    try {
      let value = '';
      
      switch(data.key){
        case 'gender'              :
          if( data.value[0].value ) value = '男性';
          if( data.value[1].value ) value = '女性';
          break;
        case 'category'            : 
          Const.value.category.map((d) => {
            if( data.value == d.id ) value = d.name;
          });
          break;
        case 'generation'          :
          value = data.value[0] +'0代～'+ data.value[1] +'0代';
          break;
        case 'followers'           :
          if( data.value[0] == null ) data.value[0] = '';
          if( data.value[1] == null ) data.value[1] = '';
          value = data.value[0] +'～'+ data.value[1]+'人';
          break;
        case 'engagement'          :
          value = data.value[0] +'%～'+ data.value[1]+'%';
          break;
        case 'share_pt'            :
          if( data.value[0] == null ) data.value[0] = '';
          if( data.value[1] == null ) data.value[1] = '';
          value = data.value[0] +'～'+ data.value[1];
          break;
        case 'prefectures'         :
          Const.value.prefectures.map((d) => {
            if( data.value == d.code ) value = d.name;
          });
          break;
        case 'follower_gender'     :
          if( data.value == 1 ) value = '男性';
          if( data.value == 2 ) value = '女性';
          break;
        case 'follower_generation' :
          value = data.value +'0代';
          break;
        case 'general'             : throw 'skip';
        case 'official'            : throw 'skip';
        case 'ambiguous'           : throw 'skip';
      }
      
      return ': ' + value;
    } catch(e) {
      return '';
    }
  },
  // -------------------------------------------------------
  
  /*
   * 画面表示用のフォーマットに変更
   */
  scrollEventX(id){
    setTimeout( function(){
      let target = document.getElementById(id);
      if( target == null ) return;
      
      // 'mousewheel' を標準の 'wheel' イベントに修正（モダンブラウザ対応）
      target.addEventListener('wheel', e => {
        // 座標の取得
        var baseWidth    = target.offsetWidth;
        var scrollWidth  = target.scrollWidth;
        var scrollLeft   = target.scrollLeft;
        
        // 現在の位置
        var scrollPosition = baseWidth + scrollLeft;
        
        // 横スクロールにするか確認
        let stop = false;
        let wheel = e.deltaY;
        if( baseWidth == scrollPosition   && wheel < 0 ) stop = true;
        if( scrollWidth == scrollPosition && wheel > 0 ) stop = true;
        
        // 横スクロール処理
        if( e.deltaX === 0 && stop === false ){
          e.stopPropagation();
          e.preventDefault();
          target.scrollBy(e.deltaY, 0);
        }
      }, { passive: false }) // preventDefaultを効かせるために必要
    }, 50);
  },
  // -------------------------------------------------------
  
  /*
   * 画面表示用のフォーマットに変更
   */
  scrollEventY(id){
    setTimeout( function(){
      let target = document.getElementById(id);
      if( target == null ) return;
      
      // 'mousewheel' を標準の 'wheel' イベントに修正
      target.addEventListener('wheel', e => {
        e.stopPropagation();
        e.preventDefault();
        target.scrollBy(0, e.deltaY);
      }, { passive: false })
    }, 50);
  },
  // -------------------------------------------------------
  
  /*
   * ローカルストレージ取得
   */
  getLocalData(params){
    let data = localStorage.getItem(params.id);
    try { if( params.mode == 'json' || params.mode == 'array' ) return JSON.parse(data); } catch(e) {};
    
    if( data == undefined || data == null || data == '' ) return params.default;
    return data;
  },
  // -------------------------------------------------------
  
  /*
   * ローカルストレージ保存
   */
  saveLocalData(params){
    let data = params.data;
    try { if( params.mode == 'json' || params.mode == 'array' ) data = JSON.stringify(data); } catch(e) {};
    localStorage.setItem(params.id, data);
  },
  // -------------------------------------------------------

  /*
   * 動画ファイル判定（URL・ファイル名の拡張子から判定）
   */
  isVideo(url){
    if( url == undefined || url == null || typeof url !== 'string' ) return false;
    if( url.indexOf('data:video') === 0 ) return true;
    let path = url.split('?')[0].split('#')[0].toLowerCase();
    return /\.(mp4|m4v|mov|qt|webm|ogv|ogg|avi|wmv|flv|mkv|3gp|3g2|mpe?g|mts|m2ts|ts|hevc)$/.test(path);
  },
  // -------------------------------------------------------

}